import {logEvents, screenRecordEvent, setUserProperty} from './ClevetapService';
import { consoleLog } from '../services/common/utils';
export {RecordlogEvents, LogActions, RecordScreenEvent, setRecordUserProperty};
const LogActions = (action, title) => {
  try {
  } catch (e) {}
};

const RecordScreenEvent = (pagename,logintype,rnuserdetails) => {
    try {
      //consoleLog('RecordScreenEvent-------------------------pagename', global?.currentpage + '|' + pagename);
      //consoleLog("global.logintype:"+global?.logintype+",global?.userdetails?.msisdn:"+global?.userdetails?.msisdn+"")
      try{
        consoleLog("RecordScreenEvent:logintype:"+logintype+",rnuserdetails:"+JSON.stringify(rnuserdetails)+"")
        consoleLog("RecordScreenEvent:redux user data msisdn->:"+rnuserdetails?.msisdn+"")
    }catch{}
      let _current = global.currentpage;
      if (_current != pagename || global.currentpage == undefined) {
        global.previouspage = _current;
        global.currentpage = pagename;
        screenRecordEvent(pagename,logintype,rnuserdetails);
      }
    } catch (e) {}
  };

  const RecordlogEvents = (eventname, obj) => {
    // alert("eventname:"+eventname+"")
    // alert("obj:"+obj+"")
    try {
      consoleLog('---------RecordlogEvents', eventname);
      consoleLog('---------RecordlogEvents', obj);
      logEvents(eventname, obj);
    } catch (e) {}
  };

  const setRecordUserProperty = ({
    email,
    name,
    ContractID,
    mobileNo,
    isdigital,
    rateplantype,
    custtype,
    language,
    voiceline,
    rnuserdetails
  }) => {
    //alert("email:"+email+",name:"+name+",ContractID:"+ContractID+",mobileNo:"+mobileNo+"")
    try {
      setUserProperty({
        email,
        name,
        ContractID,
        mobileNo,
        isdigital,
        rateplantype,
        custtype,
        language,
        voiceline,
        rnuserdetails
      });
    } catch (e) {}
  };